import {useQuery} from '@tanstack/react-query';
import {getCommonSubCategory} from '@/api/help/form';

/**
 * 메인 카테고리 값에 따라 문의 유형의 하위 카테고리 목록을 조회하는 커스텀 Hook
 * @param {string | number} mainCategoryValue - 상위 카테고리의 ID 또는 값
 * @returns {QueryResult} React Query의 useQuery가 반환하는 객체
 */
export const useCommonSubCategory = (mainCategoryValue) => {
  return useQuery({
    queryKey: ['help', 'inquirySubCategory', mainCategoryValue],
    queryFn: () => getCommonSubCategory(mainCategoryValue),
    enabled: !!mainCategoryValue,
  });
};
